var map = {
	"./qld/electoral_districts": 540,
	"./wa/electoral_districts": 546
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 505;


//////////////////
// WEBPACK FOOTER
// ../data ^\.\/.*\/electoral_districts$
// module id = 505
// module chunks = 0